import React from 'react';

import { AvatarIcon, Radio } from '@infoods/lifebase-ui';

import classes from './CoachRow.module.scss';
import { Coach } from '../../../../../../interfaces/coachList/CoachListInfo';
import { SelectableCard } from '../../../../../../../shared/components/form-components';

type CoachRowProps = {
  coach: Coach;
  selectedCoachId?: number | null;
  onClick: (coach: Coach) => void;
};

const CoachRow = ({ coach, selectedCoachId, onClick }: CoachRowProps) => {
  const checked = selectedCoachId === coach.coachId;

  const handleClick = () => {
    onClick(coach);
  };

  return (
    <SelectableCard
      className={classes.row}
      variant="outBox"
      onClick={handleClick}
      data-test-id="coach-row"
    >
      <div className={classes.coachCell}>
        <Radio checked={checked} />
        <AvatarIcon userName={coach.coachName} avatarImgLink={coach.coachAvatar} />
        <div> {coach.coachName}</div>
      </div>
    </SelectableCard>
  );
};

export { CoachRow };
